import React from "react";
import '../Questionnaire/SignUpPage/LoadingSpinner.css';

interface LoadingSpinnerProps {
  text?: string; // 可选的文本属性
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text = "Loading..." }) => {
  return (
    <div className="loading-overlay">
      <div className="spinner-container">
        <div className="spinner"></div>
        <p className="loading-text">{text}</p> {/* 动态展示文本 */}
      </div>
    </div>
  );
};

export default LoadingSpinner;
